<template>
  <div>
    <h1 class="mb-8 font-bold text-4xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('exercises')">Ejercicio</inertia-link>
      <span class="text-white font-medium">/Crear</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-3/6" label="Nombre" required/>
          <div class="pr-6 pb-8 w-full lg:w-6/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Nivel:</label>
            <VueMultiselectComponent
              class="form-input bg-inexinput text-inexorange  border-inexgray focus:border-inexorange w-full"
              v-model="form.nivel_id"
              :options="niveless"
            />
          </div>
          <text-input v-model="form.count" :error="form.errors.count" class="pr-6 pb-8 w-full lg:w-1/6" label="Cantidad"/>
          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-5/6" label="Descripción"/>
          <text-input v-model="form.videoUrl" :error="form.errors.videoUrl" class="pr-6 pb-8 w-full lg:w-6/6" label="Url Video Google Drive"/>

            </div>
             <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-2 btn-indigoOrange" type="submit">Agregar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueMultiselectComponent from 'vue-multiselect-component'
import axios from "axios";

export default {
  metaInfo: { title: 'Agregar Ejercicio' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput,
    vSelect,
    VueMultiselectComponent
  },
  layout: Layout,
  props: {
    niveles: Array,
  },
  remember: 'form',
  data() {
    return {
      mensagge: '',
      niveless: this.niveles,
      form: this.$inertia.form({
        name: null,
        description: null,
        nivel_id: [],
        videoUrl: null,
        count: null,

      }),
    }
  },
  methods: {
    store() {
     this.mensagge='';
       var data = new FormData();
       data.append('video', this.form.video);
       data.append('description', this.form.description);
       data.append('name', this.form.name);
       data.append('count', this.form.count);
       data.append('niveles', this.form.nivel_id);
       data.append('_method', 'POST');
       axios.post('/exercises',data).then(response => {
          this.mensagge=response.data;
      }); 
    },
  },
}
</script>
